import { Component } from '@angular/core';
import { PinShapeSvg } from './pin-shape-svg';

@Component({
  selector: 'topo-circle-svg',
  standalone: true,
  template: `
    <svg viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
      <circle cx="15" cy="15" r="12" [attr.fill]="color()" />
    </svg>
  `
})
export class CircleSvgComponent extends PinShapeSvg {}
